import React from 'react';
import { useTranslations } from 'next-intl';

import { Stats } from 'modules/lesson-detail';

interface IProps {
  lessonCount?: number;
  duration?: number;
}

export const Header = ({ duration, lessonCount }: IProps) => {
  const t = useTranslations();

  return (
    <div className="flex sm:items-center flex-col sm:flex-row justify-between sm:px-4">
      <p className="font-semibold">{t('kurs_tarkibi')}</p>
      <Stats lessonCount={lessonCount} duration={duration} className='flex-wrap' />
    </div>
  );
};
